import React from "react";
import socketio from "socket.io-client";

export const socket = socketio.connect(process.env.REACT_APP_WEB_SERVICE);
export const SocketContext = React.createContext(socket);


export default socket;